import { render, staticRenderFns } from "./page-game_profile.vue?vue&type=template&id=4441c2bc&scoped=true"
import script from "./page-game_profile.vue?vue&type=script&lang=js"
export * from "./page-game_profile.vue?vue&type=script&lang=js"
import style0 from "./page-game_profile.vue?vue&type=style&index=0&id=4441c2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4441c2bc",
  null
  
)

export default component.exports